import { NgModule } from '@angular/core';
import { RouteAreaActiveDirective } from './route-area-active.directive';

@NgModule({
   declarations: [RouteAreaActiveDirective],
   exports: [RouteAreaActiveDirective],
})
export class RouteAreaActiveModule {}
